import type { StockStatus } from "@/lib/admin-api/inventory";

interface StockStatusBadgeProps {
  readonly status: StockStatus;
}

const CONFIG: Record<StockStatus, { label: string; className: string }> = {
  in_stock: {
    label: "En stock",
    className:
      "bg-emerald-50 text-emerald-700 border border-emerald-200",
  },
  low_stock: {
    label: "Faible",
    className:
      "bg-amber-50 text-amber-700 border border-amber-200",
  },
  out_of_stock: {
    label: "Rupture",
    className:
      "bg-red-50 text-red-700 border border-red-200",
  },
};

export function StockStatusBadge({ status }: StockStatusBadgeProps) {
  const { label, className } = CONFIG[status];
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${className}`}
    >
      {label}
    </span>
  );
}
